import React, { useState } from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";
import { T, PRI_DOT, STATUS_BG, STATUS_TEXT, STATUS_LABEL } from "../../constants/todoTokens";

const NoDateStrip = ({ tasks, onTaskClick }) => {
  const [expanded, setExpanded] = useState(false);
  if (!tasks.length) return null;

  const shown = expanded ? tasks : tasks.slice(0, 3);

  return (
    <Box
      sx={{
        mt: 2,
        bgcolor: T.surface,
        borderRadius: "12px",
        border: `1px solid ${T.border}`,
        overflow: "hidden",
        boxShadow: T.shadow.sm,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        onClick={() => setExpanded((e) => !e)}
        sx={{
          px: 2.5, py: 1.5,
          bgcolor: "#F8FAFC",
          borderBottom: `1px solid ${T.border}`,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: T.textSub }}>
          No due date — {tasks.length} task{tasks.length !== 1 ? "s" : ""}
        </Typography>
        <Typography sx={{ fontSize: "11px", color: T.primary, fontWeight: 700 }}>
          {expanded ? "Hide" : "Show all"}
        </Typography>
      </Stack>

      <Box sx={{ p: 1.5 }}>
        <Stack spacing={1}>
          {shown.map((task) => (
            <Box
              key={task._id}
              onClick={() => onTaskClick(task)}
              sx={{
                display: "flex", alignItems: "center", gap: 1,
                px: 1.5, py: 1,
                borderRadius: "8px",
                border: `1px solid ${T.border}`,
                borderLeft: `3px solid ${PRI_DOT[task.priority] || "#94A3B8"}`,
                cursor: "pointer",
                bgcolor: "#fff",
                transition: "background 0.15s",
                "&:hover": { bgcolor: T.primaryLight },
              }}
            >
              <Typography
                sx={{
                  flex: 1, fontSize: "12px", fontWeight: 600, color: T.text,
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}
              >
                {task.title || "Untitled"}
              </Typography>
              <Chip
                label={STATUS_LABEL[task.status] || "—"}
                size="small"
                sx={{
                  bgcolor: STATUS_BG[task.status]   || "#F1F5F9",
                  color:   STATUS_TEXT[task.status] || "#475569",
                  fontWeight: 700, fontSize: "10px", height: 18, borderRadius: "4px",
                }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default React.memo(NoDateStrip);
